import React, { Component } from "react";
import { connect } from "react-redux";
import { getSelectedWebsiteDomain, getSelectedWebsiteRegionalDatabase } from "../../store/tracked_websites/selectors";
import { getKeywordResearchTitle } from "../../store/keyword_research/selectors";
import { getDefaultOrderBy, getDefaultOrderDir } from "../../store/top_keywords/selectors";
import KeywordResearchLayout from "../../components/KeywordResearch/KeywordResearchLayout";

class KeywordResearch extends Component {
  render() {
    return (
      <KeywordResearchLayout
        domain={this.props.domain}
        seoDb={this.props.seoDb}
        title={this.props.title}
        orderBy={this.props.defaultOrderBy}
        orderDir={this.props.defaultOrderDir}
      />
    );
  }
}

const mapStateToProps = state => ({
  domain: getSelectedWebsiteDomain(state),
  seoDb: getSelectedWebsiteRegionalDatabase(state),
  title: getKeywordResearchTitle(state),
  defaultOrderBy: getDefaultOrderBy(state),
  defaultOrderDir: getDefaultOrderDir(state)
});

export default connect(mapStateToProps)(KeywordResearch);
